import { getHttpMethods, respond } from "../Components/Utils/httpMethods";
import { enAPI } from "../../src/config";
import { hasPrivilege } from "../Components/Utils/utils";

export const staticPoolRoles = [
	{
		label: 'REPOST-DEV',
		id: 'REPOST-DEV'
	},
];

export const getRoles = () => {
	return (dispatch, state) => {
		const http = getHttpMethods(dispatch, state);
		let store = state();
		let assignedUserPoolRoles = store.pool.userPoolRoles,
			superAdmin = store.account.superAdmin;
		dispatch({ type: 'SET_LOADING', data: { isLoading: true } });
		http
			.get(`${enAPI}ADMIN_PORTAL/getroles`)
			.then(res => {
				const roles={
				       roles:{
							"REPOST-DEV":["REPOST-DEV_CREATE","REPOST-DEV_MODIFY","REPOST-DEV_VIEW","REPOST-DEV_ADMIN","REPOST-DEV_REAPPROVE","REPOST-DEV_REVIEW","REPOST-DEV_RESET","REPOST-DEV_GENERATE_REPORT"]
						}


					};
				const statictRoles = [
					{
						label: 'REPOST-DEV',
						id: 'REPOST-DEV',
						disabled: !hasPrivilege(assignedUserPoolRoles, ['REPOST-DEV_ADMIN'], superAdmin)
					}
				];
				dispatch({
					type: 'SET_ADMIN_ROLES_LIST',
					data: { roles: roles, staticPoolRoles: statictRoles }
				});
				dispatch({ type: 'SET_LOADING', data: { isLoading: false } });
			})
			.catch(err => {
				dispatch({ type: 'SET_LOADING', data: { isLoading: false } });
				respond('getRolesList', err, dispatch);
			});
	};
};

export const adminCreateUser = (formvalues, email) => {
  return (dispatch, state) => {
    const http = getHttpMethods(dispatch, state);
    dispatch({ type: "SET_LOADING", data: { isLoading: true } });
    http
      .get(
        `${enAPI}ADMIN_PORTAL/emailverify?email=${encodeURIComponent(email)}`
      )
      .then((res) => {
        let emailExists = res.data && res.data.email;
        if (!emailExists) {
          http
            .post(`${enAPI}ADMIN_PORTAL/admin/createuser`, {
              Attributes: formvalues,
              email,
            })
            .then((res) => {
              dispatch({ type: "SET_LOADING", data: { isLoading: false } });

              dispatch({
                type: "SET_ADMIN_CREATE_USER",
                data: { usercreated: "User Created Successfully" },
              });
            })
            .catch((err) => {
              dispatch({ type: "SET_LOADING", data: { isLoading: false } });
              respond("getRolesList", err, dispatch);
            });
        } else {
          dispatch({ type: "SET_LOADING", data: { isLoading: false } });
          respond(
            "userExists",
            {
              message: "User with given email already exists",
            },
            dispatch
          );
        }
      })
      .catch((err) => {
        dispatch({ type: "SET_LOADING", data: { isLoading: false } });
        respond("searchUsers", err, dispatch);
      });
  };
};

export const getAdminUsers = (
  attribute_name,
  attribute_value,
  modifyAdminList
) => {
  return (dispatch, state) => {
    const http = getHttpMethods(dispatch, state);
    // let store = state();
    // let superAdmin = store.account.superAdmin;
    dispatch({ type: "SET_LOADING", data: { isLoading: true } });
    let input = {
      name: attribute_name,
      value: attribute_value,
      action: modifyAdminList && "admins",
    };
    http
      .post(`${enAPI}ADMIN_PORTAL/searchusers`, input)
      .then((res) => {
        let users = [];
        res.data &&
          res.data.Users.forEach((user) => {
            let Attributes = {};
            user.Attributes.forEach((attr) => {
              Attributes[attr.Name] = attr.Value;
            });
            users.push({
              ...user,
              ...Attributes,
            });
          });
        // let finalList =
        // 	modifyAdminList && !superAdmin
        // 		? users.filter(user => {
        // 				let userIsSuperAdmin =
        // 					user['custom:accessrole'] && user['custom:accessrole'].split(',').includes('COGNITO_SUPER_ADMIN');
        // 				return !userIsSuperAdmin;
        // 		  })
        // 		: users;
        let lastKey = {
          lastEvaluatedKey: res.data.PaginationToken,
        };
        dispatch({
          type: "ADMIN_USERS_LIST",
          data: { usersList: users, lastKey: lastKey },
        });
        dispatch({
          type: "SET_ADMIN_SEARCH_ATTRIBUTE",
          data: {
            searchAttributes: {
              name: attribute_name,
              value: attribute_value,
              action: modifyAdminList && "admins",
            },
          },
        });
        dispatch({ type: "SET_LOADING", data: { isLoading: false } });
      })
      .catch((err) => {
        dispatch({ type: "SET_LOADING", data: { isLoading: false } });
        respond("getUsersList", err, dispatch);
      });
  };
};

export const getAdminUserDetails = (username) => {
  return (dispatch, state) => {
    dispatch({ type: "RESET_ERROR" });
    dispatch({ type: "SET_LOADING", data: { isLoading: true } });
    const http = getHttpMethods(dispatch, state);
    http
      .get(`${enAPI}ADMIN_PORTAL/getuser/${username}`)
      .then((res) => {
        dispatch({ type: "SET_LOADING", data: { isLoading: false } });
        let Attributes = {};
        res.data.UserAttributes.forEach((attr) => {
          Attributes[attr.Name] = attr.Value;
        });
        dispatch({
          type: "SET_ADMIN_USER_DETAILS",
          data: { userDetails: { ...res.data, ...Attributes } },
        });
      })
      .catch((err) => {
        dispatch({ type: "SET_LOADING", data: { isLoading: false } });
        respond("getUserDetails", err, dispatch);
        console.log("error:", err);
      });
  };
};
export const updateAdminUser = (username, Attributes) => {
  return (dispatch, state) => {
    dispatch({ type: "RESET_ERROR" });
    dispatch({ type: "SET_LOADING", data: { isLoading: true } });
    const http = getHttpMethods(dispatch, state);
    http
      .post(`${enAPI}ADMIN_PORTAL/admin/updateuser`, {
        Attributes,
        email: username,
      })
      .then((res) => {
        dispatch({ type: "SET_LOADING", data: { isLoading: false } });
        dispatch({
          type: "SET_ADMIN_MODIFY_USER",
          data: { usermodified: res.data },
        });
      })
      .catch((err) => {
        dispatch({ type: "SET_LOADING", data: { isLoading: false } });
        respond("getUserDetails", err, dispatch);
        console.log("error:", err);
      });
  };
};
export const errorWhileFetch = (err) => {
  return (dispatch, state) => {
    dispatch({
      type: "SET_ERROR",
      data: { error_obj: { errorPath: err } },
    });
  };
};

export const setUserList = (list, lastKey) => {
  return (dispatch) => {
    dispatch({
      type: "USERS_LIST",
      data: { usersList: list, lastKey: lastKey },
    });
  };
};
